import React from 'react';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import MessageDisplayBoxWithTruncation from 'Components/ComponentLibrary/Molecules/MessageDisplayBoxWithTruncation';
import fr from 'facet-rest';
import {
  FDBodyText, FDBox, FDClickableText, FDStack,
} from '@facet-wealth/design';

const SystemNewRoutedThreadContent = ({ relatedMessage, messageResource, onRoutedThreadClick }) => {
  return (
    <FDStack spacing={3} direction={'column'} paddingY={1} {...dataAttrs('message-with-routed-thread-content')}>
      {relatedMessage ? (
        <MessageDisplayBoxWithTruncation messageContent={relatedMessage.attr('content')} />
      ) : null}
      <FDBox>
        { messageResource.withRelationship(fr.relationships.specificThreadLink.name,
          (rel) => {
            return <span>{rel.meta('prePrompt')}&nbsp;<FDClickableText appearance={'standalone'} label={rel.meta('prompt')} onClick={() => onRoutedThreadClick(rel)} {...dataAttrs('routed-thread-clickable-text')} />&nbsp;{rel.meta('postPrompt')}</span>;
          },
          () => <FDBodyText value={'To speed things up for you, I\'ve started a new thread.'} />)
        }
      </FDBox>
    </FDStack>
  );
};

SystemNewRoutedThreadContent.propTypes = {
  relatedMessage: PropTypes.instanceOf(fr.Resource).isRequired,
  messageResource: PropTypes.instanceOf(fr.Resource).isRequired,
  onRoutedThreadClick: PropTypes.func.isRequired,
};

SystemNewRoutedThreadContent.defaultProps = {};

export default SystemNewRoutedThreadContent;
